import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%'
  },
  button: {
    marginTop: 10
  },
  field: {
    width: '100%'
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '10px 0px 15px',
    [Device.mobile]: {
      justifyContent: appConfig.balanceAndLastBillQuery.showCancelButton ? 'space-around' : 'flex-start'
    }
  },
  cancel: {
    marginRight: 10
  }
};
